import { useTranslations } from 'next-intl';
import { CatButton } from 'blocks-nextjs/blocks-react/components/Button';
import { CatIconWarningCircle } from 'blocks-nextjs/blocks-react/components/Icons/WarningCircle';
import { CatInlineNotification } from 'blocks-nextjs/blocks-react/components/InlineNotification';
import { useEsiteCtx } from 'services/esite/context';
import { CONTACT_DEALER_LINK } from 'constants/links';
import { normalizeCommerceLink } from 'utils/links';
import { getRelativeURLWithParams } from 'utils/url';

export const UserConsentError = ({
  dealerStoreId
}: {
  dealerStoreId: string;
}) => {
  const t = useTranslations();
  const { catalogId, langId } = useEsiteCtx();

  const contactDealerLink = normalizeCommerceLink(
    getRelativeURLWithParams(CONTACT_DEALER_LINK, {
      catalogId,
      langId,
      storeId: dealerStoreId
    })
  );

  const getTitle = () => {
    const title = t('UNKNOWN_ERROR_TITLE');
    return `${title[0].toUpperCase()}${title.slice(1).toLowerCase()}`;
  };

  return (
    <div className="mt-4">
      <CatInlineNotification
        variant="error"
        data-testid="map-results-error"
        heading={getTitle()}
      >
        <CatIconWarningCircle slot="before" data-testid="error-icon" />
        {t('UNKNOWN_ERROR_MESSAGE')}
        <div slot="after">
          <CatButton
            type="button"
            variant="ghost"
            className="text-nowrap mt-md-2 pt-2 pt-md-0"
            href={contactDealerLink}
          >
            {t('FOOTER_CONTACT_US')}
          </CatButton>
        </div>
      </CatInlineNotification>
    </div>
  );
};
